import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from '../../RgInteraction.module.scss';

const CasinoLoss = ({
  closeRgPopup,
  goToRgTools,
}) => (
  <Fragment>
    <div>
      <div className={styles.title}>
        Please Gamble Responsibly
      </div>
      <div className={styles.bold}>
        {'Are you aware of your recent losses? We can see that you suffered losses on the casino recently.'}
      </div>
      <div>
        <span>{'Research shows that taking regular breaks and setting up a deposit limit which suits your budget and sticking to it is an effective method to remain in control.'}</span>
        <br />
        <br />
        <span>{'Would you like to review your Safer Gambling settings?'}</span>
      </div>
    </div>
    <div className={styles.containerActions}>
      <Button
        sizeType="wider"
        buttonType="flat"
        onClick={closeRgPopup}
      >{"No, I'm fine for now"}</Button>
      <Button
        sizeType="wider"
        buttonType="primary"
        onClick={goToRgTools}
        className={styles.primaryButton}
      >Yes, Review my settings</Button>
    </div>
  </Fragment>
);

CasinoLoss.propTypes = {
  closeRgPopup: PropTypes.func.isRequired,
  goToRgTools: PropTypes.func.isRequired,
};

export default CasinoLoss;

